var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "256px",
    height: "256px",
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0.295,119.3972 C25.109,176.4012 88.073,185.9602 163.22,137.6432 C197.88,169.7222 206.515,207.7532 177.594,246.0352 C162.341,252.4512 145.586,255.9992 128,255.9992 C57.308,255.9992 -2.84217094e-14,198.6922 -2.84217094e-14,127.9992 C-2.84217094e-14,125.1082 0.106,122.2412 0.295,119.3972 Z M117.3535,94.6526 C128.5585,47.9576 159.8475,21.1736 209.0315,28.9156 C237.7015,52.3896 256.0005,88.0556 256.0005,127.9996 C256.0005,178.3946 226.8735,221.9786 184.5405,242.8566 C222.9965,188.0726 191.5705,130.2726 117.3535,94.6526 Z M128.0006,-1.42108547e-14 C155.4356,-1.42108547e-14 180.8516,8.635 201.6876,23.33 C131.7366,15.198 98.7036,73.505 103.3176,154.024 C57.8656,167.965 20.8376,157.693 1.2696,109.977 C10.0306,47.819 63.4266,-1.42108547e-14 128.0006,-1.42108547e-14 Z",
    fill: "#662D91"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppium);
export default __webpack_public_path__ + "static/media/Appium.529d284139a8130f17c37e4fd5c61ce6.svg";
export { ForwardRef as ReactComponent };